export const getErrorsMessages = (errors = []) => errors.map((error) => error.message);

export const getErrorsCode = (errors = []) => errors.map((error) => error.code);

export const strToFloat = (value) => parseFloat(String(value).replace('.', '').replace(',', '.'));

export function runSchemaValidator(schema, values, errorsAccumulator = {}) {
  const errors = {
    ...Object.freeze(errorsAccumulator),
  };

  Object.keys(schema).forEach((field) => {
    const value = values[field];
    const validators = schema[field];

    if (!Array.isArray(validators)) {
      const subErrors = runSchemaValidator(validators, value || {});

      if (Object.keys(subErrors).length) {
        errors[field] = subErrors;
      }

      return;
    }

    validators.forEach(({ message, validate }) => {
      if (validate(value, values)) {
        return true;
      }

      if (!Array.isArray(errors[field])) {
        errors[field] = [];
      }

      return errors[field].push(message);
    });
  });

  return errors;
}

export const customArrayMutators = {
  merge: ([name, value], state, { changeValue }) => {
    changeValue(state, name, (array) => (array ? [...array, ...value] : [value]));
  },
  removeBatch: ([name, indexes], state, { changeValue }) => {
    changeValue(state, name, (array) => array.filter((obj, i) => indexes.indexOf(i) === -1));
  },
};

export const customMutators = {
  setAllFields: ([prop, value], { fields }) => {
    Object.keys(fields).forEach((name) => {
      const field = fields[name];
      field[prop] = value;
    });
  },
  setValue: ([fieldName, value], state, { changeValue }) => {
    const field = state.fields[fieldName];
    if (field) {
      changeValue(state, fieldName, () => value);
    }
  },
};
